<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-size-100">
        <edit-profile-form
          header-color="primary"
          v-bind:organization="organization"
          v-bind:ogOrganization="ogOrganization"
          v-on:dirty="orgChanged"
        ></edit-profile-form>
      </div>      
    </div>
    <submit-snackbar
      v-bind:validationError="validationError"
      v-bind:dirty="getDirty()"
      v-bind:errorsOccurred="submitErrorsOccurred"
      v-on:submit="updateConfig"
    ></submit-snackbar>
  </div>
</template>

<script>
import { EditProfileForm, EditOrgDetailsForm } from "@/pages";
import { SubmitSnackbar } from "@/fmComponents";
import { get } from "vuex-pathify";
import { updateOrganization } from "../../utils/appcues";
import validationRules from '../../validationRules';
export default {
  components: {
    SubmitSnackbar,
    EditProfileForm,
    EditOrgDetailsForm
  },
  computed: {
    validationError : function(){
      return this.$v.organization.primaryContact.$anyError;
    },
    organization: get("organization/organization"),
    ogOrganization: get("organization/ogOrganization"),
    submitErrorsOccurred: get("organization/errorsOccurred")
  },
  data: () => ({
    primaryContactDirty: false,
    orgDirty: false
  }),
  created() {
    if (localStorage.organizationId) {
      this.$store.dispatch(
        "organization/loadOrganization",
        localStorage.organizationId
      );
    }
  },
  methods: {
    orgChanged: function(where, dirty) {
      if(where === "primaryContact") {
        this.primaryContactDirty = dirty;
      } else {
        this.orgDirty = dirty;
      }
    },
    updateConfig: function() {
      if (this.validationError){
        this.$store.commit("pushError", "Your change has one or more errors.");
      } else{
        this.updateCardErrorCount = 0;
        var me = this;
        this.$store
          .dispatch("organization/updateOrganization", me.organization)
          .then((result) => {
            updateOrganization(result);
            me.orgDirty = false;
            me.primaryContactDirty = false;
          });
      }
    },
    getDirty: function() {
      this.$v.organization.primaryContact.$touch();
      if (this.primaryContactDirty || this.orgDirty) {
        return true;
      }
      return false;
    }
  },
  validations () {
    return validationRules;
  }
};
</script>
